export const WEBSITES_RESET_STATE = 'WEBSITES_RESET_STATE';
export const WEBSITES_CURRENT_ITEM = 'WEBSITES_CURRENT_ITEM';
 
export const WEBSITES_REQUEST_LOADING = 'WEBSITES_REQUEST_LOADING';
export const WEBSITES_REQUEST_SUCCESS = 'WEBSITES_REQUEST_SUCCESS';
export const WEBSITES_REQUEST_FAILED = 'WEBSITES_REQUEST_FAILED';
 
export const WEBSITES_CURRENT_ACTION = 'WEBSITES_CURRENT_ACTION';
export const WEBSITES_RESET_ACTION = 'WEBSITES_RESET_ACTION';